import { Badge } from '@/components/ui/badge';
import { cn } from 'src/lib/utils';

import { useAppCard, CRITICALITY_LABEL, type AppCardData } from '../model';

import { DetectedProductRow } from './DetectedProductRow';

const CRITICALITY_BARS: Record<AppCardData['criticality'], number> = {
  standard: 1,
  important: 2,
  business_critical: 3,
};

const Tag = ({ children }: React.PropsWithChildren) => (
  <Badge variant="pill" className="px-2 py-0.5 text-xs font-semibold text-slate-700">
    {children}
  </Badge>
);

const CriticalityMeter = ({ filled }: { filled: number }) => (
  <span className="flex items-end gap-1" aria-hidden="true">
    {[1, 2, 3].map((bar) => (
      <span
        key={bar}
        className={cn('w-0.75 bg-current', bar <= filled ? 'opacity-100' : 'opacity-25')}
        style={{ height: `${bar * 3 + 2}px` }}
      />
    ))}
  </span>
);

const TagRow = () => {
  const { data } = useAppCard();

  if (!data.claimed) return <DetectedProductRow />;

  return (
    <div className="flex flex-wrap gap-1">
      <Tag>
        <CriticalityMeter filled={CRITICALITY_BARS[data.criticality]} />
        {CRITICALITY_LABEL[data.criticality]}
      </Tag>
      {Boolean(data.extraTags.length) && <Tag>+{data.extraTags.length}</Tag>}
    </div>
  );
};

export { TagRow, CriticalityMeter, CRITICALITY_BARS };
